module.exports = __webpack_public_path__ + "img/news-02.5f716c2d.jpg";